module.exports = __webpack_public_path__ + "static/dcb8b2ca2cb631a128c8e81ec4aaa69ff78d1fe2210a881beb0b376f787b6ee0-f47cd297af9c2284dd569bb8ce5e61f8.png";